import script from "./collection-list.vue?vue&type=script&setup=true&lang=js"
export * from "./collection-list.vue?vue&type=script&setup=true&lang=js"

import "./collection-list.vue?vue&type=style&index=0&id=38c16f4b&scoped=true&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c16f4b"]])

export default __exports__